import { useMutation } from '@tanstack/react-query'

import { updateScimConfiguration } from '@src/api'
import { DefaultApiUpdateScimConfigurationRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateScimConfiguration = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiUpdateScimConfigurationRequest) =>
      updateScimConfiguration(axiosInstance, params),
  })
}
